import { CrossSellingPointer } from "../../others";
import { RCL } from ".";

const crossRclAssignGutenberg = () => CrossSellingPointer.waitForVisibleElement("body.wp-admin .editor-post-taxonomies__hierarchical-terms-list:visible", RCL, "assign", "bottom");

export { crossRclAssignGutenberg };